import { BKPR_PREFIX } from '../constants';

/**
 * Strip the base path and Beekeeper prefix from the URL.
 * If the URL starts with /{instanceSlug}/bk/, we remove both the /{instanceSlug} and /bk/ prefixes.
 * @param path
 * @param instanceSlug
 * @param isBkprPath
 * @returns string
 */
export const stripBasePath = (path: string, instanceSlug: string, customerSlug: string, isBkprPath: boolean) => {
    let pathWithoutPrefixNorInstance = path.startsWith(`/${instanceSlug}/`)
        ? path.replace(`/${instanceSlug}`, '')
        : path;
    pathWithoutPrefixNorInstance = path.startsWith(`/a/${customerSlug}/${instanceSlug}/`)
        ? path.replace(`/a/${customerSlug}/${instanceSlug}`, '')
        : pathWithoutPrefixNorInstance;
    pathWithoutPrefixNorInstance = isBkprPath
        ? pathWithoutPrefixNorInstance.replace(BKPR_PREFIX, '')
        : pathWithoutPrefixNorInstance;

    return pathWithoutPrefixNorInstance;
};
